import { AxiosPromise } from 'axios';
import {
  IGetSpeakingItem,
  IGetSpeakingItems,
  IGetSpeakingScore,
  ISpeakingItem,
} from '../models/speaking.model';
import axios from 'axios';

const uri = '/mgmt/speaking';

export const getSpeakingItem = (evaluationItemCode: number): AxiosPromise<IGetSpeakingItem> => {
  return axios.get(`${uri}/evaluation-item/${evaluationItemCode}`);
};

export const getSpeakingItems = (): AxiosPromise<IGetSpeakingItems> => {
  return axios.get(`${uri}/evaluation-item`);
};

export const createSpeakingItem = (data: ISpeakingItem): AxiosPromise => {
  return axios.post(`${uri}/evaluation-item`, data);
};

export const updateSpeakingItem = (
  evaluationItemCode: number,
  data: ISpeakingItem,
): AxiosPromise => {
  return axios.put(`${uri}/evaluation-item/${evaluationItemCode}`, data);
};

export const getSpeakingScore = (examTestCode: number): AxiosPromise<IGetSpeakingScore> => {
  return axios.get(`${uri}/${examTestCode}/level`);
};
